import uajs from './module/ua';
// 共通

(function ($) {
	const ua = uajs();

	$(document).ready(function () {

		// アンカーリンク
		$('a[href*="#"]').click(function () {
			const speed = 400;
			const target = $(this.hash === '#' || '' ? 'html' : this.hash)
			if (!target.length) return;
			const targetPos = target.offset().top;
			$('html, body').animate({ scrollTop: targetPos }, speed, 'swing');
			return false;
		});

		// Gnavスクロールでclacc追加
    // var $header = $(".l-header");
    // var headerHeight = $header.outerHeight();
    // $(window).scroll(function(){
    //   if ( $(this).scrollTop() > headerHeight){
		// 		$header.addClass("js-fixed");
    //   }else{
		// 		$header.removeClass("js-fixed");
    //   }
    // });

		// Gnav class追加、スクリーンリーダーでbuttonの開閉を認識
		$('.l-nav__btn.js-gnav').click(function (e) {
			e.preventDefault();
				$(".l-header__contents").toggleClass("l-nav__contents-open");
				if ($(this).attr('aria-expanded') == 'true') {
					$(this).attr('aria-expanded', 'false');
					$(".l-nav__body").attr('aria-hidden', 'true');
				} else {
					$(this).attr('aria-expanded', 'true');
					$(".l-nav__body").attr('aria-hidden', 'false');
				}
		});

		// $(window).on('load resize', function () {
		// 	if (window.innerWidth <= 767) {
		// 		$(".l-nav__body").attr('aria-hidden', 'true');
		// 	} else {
		// 		$(".l-nav__body").attr('aria-hidden', 'false');
		// 	}
		// });

		// Gnav ページ内リンクをクリックしたらハンバーガーメニューを閉じる
		$('.l-nav__link').on('click', function () {
		$(".l-header__contents").removeClass('l-nav__contents-open');
		if ($(".l-nav__btn.js-gnav").attr('aria-expanded') == 'false') {
				$(".l-nav__btn.js-gnav").attr('aria-expanded', 'true');
				$(".l-nav__body").attr('aria-hidden', 'false');
			} else {
				$(".l-nav__btn.js-gnav").attr('aria-expanded', 'false');
				$(".l-nav__body").attr('aria-hidden', 'true');
			}
		});

		// PageTop
    var threshold = 200
    var topBtn = $('.l-footer__pagetop');
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > threshold) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });

    topBtn.on('click', function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
		});

		// PageTopフッター手前でストップ
		$('.l-footer__pagetop').hide();
		$(window).on('scroll', function () {
			scrollHeight = $(document).height();
			scrollPosition = $(window).height() + $(window).scrollTop();
			footHeight = $('.l-page__footer').innerHeight();
			if (window.innerWidth <= 768) {
				if (scrollHeight - scrollPosition <= footHeight) {
					// SPフッター上の位置
					$('.l-footer__pagetop').css({
						position: "absolute",
						bottom: footHeight + 125,
					});
				} else {
					// SPスクロール中
					$('.l-footer__pagetop').css({
						position: "fixed",
						bottom: "6.6vw",
					});
				}
			} else {
				$('.l-footer__pagetop').css({
					position: "fixed",
					bottom: "45px",
				});
			}
		});

		// buy-item slick
		function checkBreakPoint() {
			w = $(window).width();
			if (w <= 767) {
				$('.js-buy-slider').not('.slick-initialized').slick({
					arrows: true,
					autoplay: true,
					dots: false,
					infinite: true,
					pauseOnFocus: false,
					speed: 800
				});
			} else {
				$('.js-buy-slider.slick-initialized').slick('unslick');
			}
		}
		// slickウインドウがリサイズする度にチェック
		$(window).resize(function () {
			checkBreakPoint();
		});
		// slick初回チェック
		checkBreakPoint();

	});

})(jQuery);

// ローディング
window.onload = function() {
  const spinner = document.getElementById('loading');
  spinner.classList.add('loaded');
}

// YouToubeAPI
let youtubeIframes = [];

window.addEventListener('DOMContentLoaded', function() {
  youtubeIframes = document.getElementsByClassName('yt-player');
  if(youtubeIframes.length) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
}, false);

function onYouTubeIframeAPIReady() {
  const players = [];
  for(let i = 0; i < youtubeIframes.length; i++) {
    players[i] = new YT.Player(youtubeIframes[i].id, {
      events: {
        'onReady': onPlayerReady
      }
    });
  }
}

function onPlayerReady(event) {
  switchVideo(event.target);
  window.addEventListener('scroll', function() {
    switchVideo(event.target);
  }, false);
}

function switchVideo(targetPlayer) {
  const playerPosition = targetPlayer.getIframe().getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset + window.innerHeight;
  const endPosition = window.pageYOffset;
  if((playerPosition < startPosition) && (playerPosition > endPosition)) {
    targetPlayer.mute();
    targetPlayer.playVideo();
  }
  else {
    targetPlayer.pauseVideo();
  }
}

// 要素をふわっと表示
function showElementAnimation() {
  var element = document.getElementsByClassName('p-fadein');
  if(!element) return; // 要素がなかったら処理をキャンセル

  var showTiming = window.innerHeight > 750 ? 100 : 40; // 要素が出てくるタイミングはここで調整 750px以下は40px
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;

  for(var i=0;i<element.length;i++) { var elemClientRect = element[i].getBoundingClientRect(); var elemY = scrollY + elemClientRect.top; if(scrollY + windowH - showTiming > elemY) {
      element[i].classList.add('js-show');
    }
  }
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);
